for (const formElem of document.querySelectorAll(".js-form-login")) {
    $(formElem).validate({
        rules: {
            login: {
                email: true,
            },
            password: {
                minlength: 8,
            },
        },
        submitHandler: function (form) {
            $(form).find('button[type="submit"]').addClass("is-loading");
            $(".js-login-error").slideUp(100);

            window.assignRecaptchaResponseToForm(form).then(() => {
                Form.ajaxPost(
                    form,
                    function (data) {
                        if (!data.status) {
                            $(".js-login-error").text(data.message).slideDown(250);
                        } else {
                            $(".js-login-success").addClass("is-visible");

                            if (window.location.hash == "#login-modal") {
                                history.pushState("", document.title, window.location.pathname);
                            }

                            // if query contains redirect parameter, redirect to it
                            var urlParams = new URLSearchParams(window.location.search);
                            if (urlParams.has("redirect")) {
                                window.location.href = urlParams.get("redirect");
                            } else {
                                window.location.reload();
                            }
                        }

                        $(form).find('button[type="submit"]').removeClass("is-loading");
                    },
                    "json"
                );
            });
        },
    });
}
